import React from 'react'
import { Slider } from 'antd'
import * as locCon from '../LocalConstants'
import * as libCon from '../community-hats-js-library/Constants'
import CustomText from './CustomText'
import { StateStoredValue } from '../hooks/StoreHooks'
import { CheckboxDefaultValue } from './CustomCheckBox'
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions'
import { RefContextLanguage } from '../providers/LanguageProvider'


export function SimpleSliderFromId({ valueID, ...props }) {

    const [value, setValue] = StateStoredValue(valueID)

    return (<SimpleSlider value={value} setValue={setValue} {...props} />)
}


export function SimpleSlider({ value, setValue, title, infoText, minValue, maxValue, step = 1, minText = null, maxText = null, includeCheckbox = false, defaultValue = libCon.NA, checkboxText = null }) {

    const i18n = RefContextLanguage()

    const isUnset = isNullOrUndefined(value) || value === defaultValue

    const markLabelStyle = {
        fontSize: 15,
        whiteSpace: 'normal',
        width: 110,
        display: 'inline-block',
        lineHeight: '1.2',
        color: 'rgba(0, 0, 0, 0.88)',
        marginTop: 10,
    }

    const setMinIfUnset = () => {
        if (isUnset) setValue(minValue)
    }

    const marks = {}
    if (!isNullOrUndefined(minText)) marks[minValue] = {
        style: { ...markLabelStyle, transform: 'translateX(0)', textAlign: 'left' },
        label: <span style={{ cursor: 'pointer' }} onClick={setMinIfUnset}>{minText}</span>,
    }
    if (!isNullOrUndefined(maxText)) marks[maxValue] = {
        style: { ...markLabelStyle, transform: 'translateX(-100%)', textAlign: 'right' },
        label: maxText,
    }

    return (
        <div className="verticalSection">
            {title !== null ? <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{title}</CustomText> : <div></div>}
            {infoText !== null ? <CustomText type={locCon.INFO_TEXT}>{infoText}</CustomText> : <div></div>}
            <div style={{ width: '90%', marginBottom: '4vh', marginTop: '1vh' }} onPointerDownCapture={setMinIfUnset}>
                <Slider
                    min={minValue}
                    max={maxValue}
                    step={step}
                    value={isUnset ? minValue : Number(value)}
                    marks={marks}
                    onChange={(val) => setValue(val)}
                />
            </div>
            {includeCheckbox ? <CheckboxDefaultValue value={value} setValue={setValue} defaultValue={defaultValue} text={checkboxText} /> : <div></div>}
            <CustomText type={locCon.INFO_TEXT} style={{ marginBottom: '1vh' }}>{`${i18n.t('answer')}: ${isUnset ? '----' : value}`}</CustomText>
        </div>
    )
}
